const formatToUpperCase = (val) => (val || '').toUpperCase();

const taxesTransactionListHeaders = [
  {
    text: ' From Date', value: 'fromDate', formatter: 'shortDate',
  },
  {
    text: 'To Date', value: 'toDate', formatter: 'shortDate',
  },
  { text: 'Tax Yr', value: 'taxYear' },
  { text: 'Tax Dist', value: 'schoolDistrict' },
  {
    text: 'Tax Amount', value: 'taxAmt', align: 'right', formatter: 'amount',
  },
  {
    text: 'Penalty', value: 'penaltyAmount', align: 'right', formatter: 'amount',
  },
  {
    text: 'Fees Amount', value: 'totalFees', align: 'right', formatter: 'amount',
  },
  {
    text: 'Total Amount', value: 'totalAmount', align: 'right', formatter: 'amount',
  },
  {
    text: 'Description', value: 'description', formatter: 'hideAndShowFields',
  },
  {
    text: 'ExMfg', value: 'isExempt', formatter: 'flagToYorEmpty',
  },
  {
    text: 'Locked', value: 'isLocked', formatter: 'flagToYorEmpty',
  },

];

const miscMtgTransactionListHeaders = [
  {
    text: 'From Date', value: 'fromDate', formatter: 'shortDate',
  },
  {
    text: 'To Date', value: 'toDate', formatter: 'shortDate',
  },
  {
    text: 'Total Mtg Tax', value: 'totalMtgTax', align: 'right', formatter: 'amount',
  },
  {
    text: 'Total Cert Fees', value: 'totalCertFees', align: 'right', formatter: 'amount',
  },
  {
    text: 'Total Miscellaneous', value: 'totalMisc', align: 'right', formatter: 'amount',
  },
  {
    text: 'Joint 4-Mill', value: 'jointMill', align: 'right', formatter: 'amount',
  },
  {
    text: 'Mv Tax Stamps', value: 'mvTaxStamps', align: 'right', formatter: 'amount',
  },
  {
    text: 'Alcoholic Bev Tax', value: 'alcoholicBevTax', align: 'right', formatter: 'amount',
  },
  {
    text: 'Motor Vehicle', value: 'motorVechicle', align: 'right', formatter: 'amount',
  },
  {
    text: 'Total Apportion Like Taxes', value: 'apportionLikeTaxes', align: 'right', formatter: 'amount',
  },
  {
    text: 'Total of Special Apportionments', value: 'totalofSpecialApportionment', align: 'right', formatter: 'amount',
  },
  {
    text: 'Other ADA', value: 'otherADA', align: 'right', formatter: 'amount',
  },
  {
    text: 'Other  Census', value: 'otherCensus', align: 'right', formatter: 'amount',
  },
  {
    text: 'Locked', value: 'isLocked', align: 'center', formatter: 'flagToYorEmpty',
  },
];

const apportionmentTransactionListHeaders = [
  { text: 'From Date', value: 'fromDate', formatter: 'shortDate' },
  { text: 'To Date', value: 'toDate', formatter: 'shortDate' },
  {
    text: 'Section', value: 'section', formatter: 'customMethod', methodDefinition: formatToUpperCase,
  },
  {
    text: 'GL Fund + Description',
    value: 'fundNo',
    formatter: 'combineName',
    combineTextFileds: ['fundNo', 'fundDesc'],
  },
  {
    text: 'Source + Description',
    value: 'sourceNo',
    formatter: 'combineName',
    combineTextFileds: ['sourceNo', 'sourceDesc'],
  },
  { text: 'Tax Unit', value: 'unit' },
  { text: 'Unit Fund', value: 'fund' },
  {
    text: 'Amount', value: 'amount', align: 'right', formatter: 'amount',
  },
  { text: 'Created From', value: 'createdFrom' },
  { text: 'Money From', value: 'moneyFrom' },
  { text: 'Remit Unit', value: 'remitUnit' },
  {
    text: 'Locked?', value: 'isLocked', formatter: 'flagToYorEmpty',
  },
];

const warrantsTransactionListHeaders = [
  { text: 'Ax From Date', value: 'axFromDate', formatter: 'shortDate' },
  { text: 'Ax To Date', value: 'axToDate', formatter: 'shortDate' },
  { text: 'GL Fund', value: 'glFund' },
  { text: 'Remit Unit', value: 'remitUnit', sortable: true },
  { text: 'Tax Unit', value: 'taxUnit' },
  { text: 'Description', value: 'unitDesc' },
  { text: 'Unit Fund', value: 'unitFund' },
  { text: 'Source #', value: 'source' },
  { text: 'Description', value: 'sourceDesc' },
  {
    text: 'Amount', value: 'amount', align: 'right', formatter: 'amount',
  },
  { text: 'Warrant #', value: 'warrant' },
  { text: 'Warrant Date', value: 'warrantDate', formatter: 'shortDate' },
];

export {
  taxesTransactionListHeaders,
  miscMtgTransactionListHeaders,
  apportionmentTransactionListHeaders,
  warrantsTransactionListHeaders,
};

export default {};
